<template>
<footer class="foot">
	<div class="wrap pd-t-md">
		<div class="foot-lay pd-b-md clearfix mg-t-bs">
			<dl class="foot-lay-item">
				<dt>{{languagePackage.LANG.products_service}}</dt>
				<dd>
					<a href="/pcb-quote">{{languagePackage.LANG.pcb_quote}}</a>
					<a href="/pcb-assembly-quote">{{languagePackage.LANG.pcb_assembly_quote}}</a>
					<!-- <a href="/pcb-assembly-quote">{{languagePackage.LANG.fpc_quote}}</a>
					<a href="/rigid-flex-pcb-quote">{{languagePackage.LANG.rigid_quote}}</a> -->
					<a href="/pcb-stencil-quote">{{languagePackage.LANG.pcb_stencil_quote}}</a>
					<a href="/pcb-capabilities">{{languagePackage.LANG.pcb_capabilities}} </a>
					<a href="/pcb-assembly-capabilities">{{languagePackage.LANG.smt_capabilities}} </a>
					<a href="/dfm.html" target="_blank">HQDFM</a>
				</dd>
			</dl>
			<dl class="foot-lay-item">
				<dt>{{languagePackage.LANG.customer_support}}</dt>
				<dd>
					<a href="https://nextpcb.zohodesk.com.cn/portal/en/kb">{{languagePackage.LANG.faq}}</a>
					<a href="/pcb-vocabulary">{{languagePackage.LANG.pcb_vocabulary}}</a>
					<a href="/pcb-product">{{languagePackage.LANG.product_center}}</a>
				</dd>
			</dl>
			<dl class="foot-lay-item">
				<dt><a href="/about-nextpcb">{{languagePackage.LANG.about_nextpcb}}</a></dt>
				<dd>
					<a href="/about-nextpcb">{{languagePackage.LANG.about_us}}</a>
					<a href="/why-us">{{languagePackage.LANG.why_us}}</a>
					<a href="/payment">{{languagePackage.LANG.payments_method}}</a>
					<!-- <a href="/pcb-factory-VR-visiting">PCB Assembly Factory Show</a> -->
					<a href="/shipment">{{languagePackage.LANG.shipping_methods}}</a>
					<a href="/certificate">{{languagePackage.LANG.certiticate}}</a>
					<a href="/blog">{{languagePackage.LANG.blog}}</a>
				</dd>
			</dl>
			<dl class="foot-lay-item">
				<dt>{{languagePackage.LANG.support}}</dt>
				<dd>
					<a href="/terms-of-service">{{languagePackage.LANG.terms_cooperation}}</a>
					<a href="/privacy-policy">{{languagePackage.LANG.privacy_policy}}</a>
					<a href="/return-policy">{{languagePackage.LANG.return_policy}}</a>
				</dd>
			</dl>
		</div>
		<div class="foot-lay foot-imgflags pd-b-md pd-t-xs clearfix">
			<dl class="foot-lay-item">
				<dt>{{languagePackage.LANG.payments_method}}</dt>
				<dd>
					<img :src="$imgList.foot_flag1">
				</dd>
			</dl>
			<dl class="foot-lay-item">
				<dt>{{languagePackage.LANG.shipping_methods}}</dt>
				<dd><img :src="$imgList.foot_flag2"></dd>
			</dl>
			<dl class="foot-lay-item">
				<dt>{{languagePackage.LANG.certiticate}}</dt>
				<dd><a href="/certificate"><img :src="$imgList.foot_flag3"></a></dd>
			</dl>
			<dl class="foot-lay-item">
				<dt>{{languagePackage.LANG.social_media}}</dt>
				<dd>
					<a rel="nofollow" href="https://bit.ly/2Lfhqq9" target="_blank"><img :src="$imgList.foot_tubiao1" alt="NEXTPCB Official youtube"></a>
					<a rel="nofollow" href="https://bit.ly/2ZgGZAR" target="_blank"><img :src="$imgList.foot_tubiao2" alt="NEXTPCB Official Facefook"></a>
					<a rel="nofollow" href="https://twitter.com/HQ_NextPCB" target="_blank"><img :src="$imgList.foot_tubiao3" alt="NEXTPCB Official Twitter"></a>
					<a rel="nofollow" href="https://bit.ly/2ZegCeO" target="_blank"><img :src="$imgList.foot_tubiao4" alt="NEXTPCB Official Instagram"></a>
					<a rel="nofollow" href="https://www.linkedin.com/company/nextpcb" target="_blank"><img :src="$imgList.foot_tubiao5" alt="NEXTPCB Official Linkedin"></a>
				</dd>
			</dl>
		</div>
		<ul class="foot-lay foot-submit pd-tb-xxl">
			<li class="foot-lay-item" style="display:flex;">
				<p class="nextpcb-introduction" v-html="languagePackage.LANG.hqonline_nextpcb_both"></p>
				<div class="nextpcb-dfm-box">
					<a href="/"> <img :src="$imgList.foot_nextpcb_logo" height="38" ></a>
					<a href="/dfm.html" target="_blank"> <img width="140" :src="$imgList.foot_hqdfm_logo"></a>
					<a ref="hqonline-href" href="" target="_blank"> <img :src="$imgList.foot_hqonline_logo" width="160"></a>
				</div>
				
			</li>
			<!-- <li class="foot-lay-item" style="width: 50%;">
				<iframe :src="`${hostName}/other/subscribe.html`" style="border: 0; overflow: hidden;" scrolling="no" width="100%" height="289px"></iframe>
			</li> -->
		</ul>
	</div>
	<div class="foot-copyright">
		<p v-html="languagePackage.LANG.foot_copyright"></p>
	</div>
</footer>
</template>
<script>

export default {
	name:"foot",
	data(){
		return {
			params:{
				name:"",
				email:"",				
				content:""
			},			
			errs:{
				name:"",
				email:"",				
				content:""
			},
			hostName:'//www.nextpcb.com'
		}
	},
	computed:{
		languagePackage(){
			return this.$store.getters.getLanguangeData || {LANG:{},MLANG:{}};
		},
		errsMsg(){
			return {
				nameEmpty: this.LANG.tips_fields_not_be_empty,
				nameErr: this.LANG.name_between,
				emailEmpty:"Please enter your email address.",
				emailErr:"Email format you entered is incorrect.",
				passwordEmpty:"Please enter your password",
				contentEmpty: this.LANG.tips_fields_not_be_empty,
				contentErr: this.LANG.tips_content_length_limit
			}
		}
	},
	mounted() {
		this.$refs['hqonline-href'].setAttribute('href', this.$tools.getHqonlineUrl())
		this.getEnvHost()
	},
	methods:{
		setErrs(key){
			let val = this.params[key];
			if(!this.$tools.regs.empty.test(val)){
				this.errs[key] = this.errsMsg[key+"Empty"];
			}else if(!this.$tools.regs[key].test(val)){
				this.errs[key] = this.errsMsg[key+"Err"];
			}else {
				this.errs[key] = "";
			}
		},
		submit(){
			for(let k in this.errs){
				if(!this.params[k]){
					return this.$alert.msg(this.errsMsg[k+"Empty"]);
				}
				if(this.errs[k]){
					return this.$alert.msg(this.errs[k]);
				}
			}
			return this.$http.post(this.$api.feedbackAdd,this.params).then((res)=>{
				if(res.status == 1){
					for(let k in this.params){
						this.$set(this.params,k,"");
					}
				}
				this.$alert.msg(res.data);
			})
		},
		getEnvHost(){
			const current=window.location.host
			if(current.includes('fat')){
				this.hostName='//fat-www.nextpcb.com'
			}
			else if(current.includes('uat')){
				this.hostName='//uat-www.nextpcb.com'
			}
		}
	}
}
</script>
<style lang="scss">
$footlaydd-height: 26px;
$footlaydt-height: 40px;
$footimgflagsbordercolor: #444444;
$foot-copyright-color: #999999;
$foot-copyright-bg: #222222;
$foot-copyrightfontsize: 13px;
$foot-copyright-height: 64px;
$foot-feedback-inputheight: 30px;
$foot-feedback-areaheight: 102px;
.foot {
	background-color: #333333;
	position: relative;
	// z-index: 101;
	//foot-lay
	&-lay {
		&-item {
			float: left;
			width: 25%;
			dt,dt a {
				font-weight: 700;
				color: $color-white;
				line-height: $footlaydt-height;
			}
			a {
				display: block;
				color: rgba(255,255,255,0.6);
				line-height: $footlaydd-height;
				margin-right: $space-padding-xs;
				&:hover {
					color: $color-white;
				}
			}
		}
		.nextpcb-introduction {
			color: #fff;
			font-size: 14px;
			font-weight: 700;
			line-height: 22px;
			min-width: 350px;
			padding-right: 60px;
		}
		.nextpcb-dfm-box {
			display: flex;
			justify-content: space-between;
			a {
				margin-right: 20px !important;
				display: flex;
				align-items: center;
			}
		}
	}
	//
	&-imgflags {
		border-top: 1px solid $footimgflagsbordercolor;
		border-bottom: 1px solid $footimgflagsbordercolor;
		a {
			display: inline-block;
		}
	}
	//foot-submit
	&-submit {
		display: table;
		width: 100%;
		.foot-lay-item {
			float: none;
			display: table-cell;
			vertical-align: middle;
		}
	}
	//
	&-copyright {
		text-align: center;
		color: $foot-copyright-color;
		font-size: $foot-copyrightfontsize;
		height: $foot-copyright-height;
		line-height: $foot-copyright-height;
		text-align: center;
		background-color: $foot-copyright-bg;
	}
	//foot-feedback
	&-feedback {
		//
		&-item {
			float: left;
			width: 50%;
			box-sizing: border-box;
			input,textarea {
				display: block;
				box-sizing: border-box;
				width: 100%;
				background-color: $color-white;
				border: 1px solid $color-white;
				border-radius: $border-radius-few;
			}
			textarea {
				height: $foot-feedback-areaheight;
				padding: $space-padding-sm;
			}
			input {
				height: $foot-feedback-inputheight;
				padding: 0 $space-padding-sm;
			}
		}
	}
}
</style>
